import RpcService from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';
import SWPaymentDestination from '@/domains/SWPaymentDestinations/SWPaymentDestination';

/**
 * DAO для статей бюджета (oracle.sw_budget_items)
 */
class SWBudgetItemsDAO {

    /**
     * Загружает список статей бюджета по назначению платежа
     */
    static async getList(
      filters: {
        swPaymentDestination: SWPaymentDestination
      }
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('sWBudgetItems.getList', {
            swPaymentDestination: { id: filters.swPaymentDestination.id },
        });
    }
}

export default SWBudgetItemsDAO;
